import flatpickr from 'flatpickr';
import locales from 'flatpickr/dist/l10n';
import { getNextDate } from './utils';

class Bookingmask {
  constructor(options = {}) {
    this.config = {
      module: document.querySelectorAll('[data-module="Bookingmask"]'),
      displayFormat: 'd/m/Y',
      dateFormat: 'd-m-Y',
      datepickerType: 'separate',
      disableMobile: false,
      locale: document.getElementsByTagName('html')[0].getAttribute('lang') || navigator.language,
      ...options
    };
  }

  init() {
    const {
      module,
      displayFormat,
      dateFormat,
      datepickerType,
      locale,
      disableMobile
    } = this.config;

    module.forEach(bookingmask => {
      const checkInDisplay = bookingmask.querySelector('[data-module="CheckInDisplay"]');
      const checkInInput = bookingmask.querySelector('[data-module="CheckInInput"]');
      const checkOutDisplay = bookingmask.querySelector('[data-module="CheckOutDisplay"]');
      const checkOutInput = bookingmask.querySelector('[data-module="CheckOutInput"]');
      const dateRangeTrigger = bookingmask.querySelector('[data-module="DateRangeTrigger"]');
      const today = new Date();
      const tomorrow = getNextDate(today);

      const setCheckInDate = (date, instance) => {
        if (!date || !instance) {
          return;
        }
        checkInDisplay.value = instance.formatDate(date, displayFormat);
        checkInInput.value = instance.formatDate(date, dateFormat);
      };

      const setCheckOutRangeDate = (dates, instance) => {
        if (!dates || !instance) {
          return;
        }
        const newCheckOutDate = dates[1] || getNextDate(dates[0]);
        checkOutDisplay.value = instance.formatDate(newCheckOutDate, displayFormat);
        checkOutInput.value = instance.formatDate(newCheckOutDate, dateFormat);
      };

      const setCheckoutDateSeparate = (date, instance) => {
        if (!date || !instance) {
          return;
        }
        checkOutDisplay.value = instance.formatDate(date, displayFormat);
        checkOutInput.value = instance.formatDate(date, dateFormat);
      };

      const onRangeDateChange = (dates, dateStr, instance) => {
        setCheckInDate(dates[0], instance);
        setCheckOutRangeDate(dates, instance);
      };

      const flatPickrOpts = {
        dateFormat: displayFormat,
        minDate: Date.now(),
        disableMobile,
        locale: {
          ...locales[locale]
        },
        clickOpens: false
      };

      if (checkInDisplay && checkInInput) {
        if (checkOutDisplay && checkOutInput) {
          if (datepickerType === 'range') {
            /**
             * Range datepicker
             */
            flatpickr(checkInDisplay, {
              ...flatPickrOpts,
              defaultDate: [today, tomorrow],
              mode: 'range',
              onReady: (selectedDates, dateStr, instance) => {
                onRangeDateChange(selectedDates, dateStr, instance);

                if (dateRangeTrigger) {
                  dateRangeTrigger.addEventListener('click', () => {
                    instance.toggle();
                  });
                }
              },
              onOpen: (selectedDates, dateStr, instance) => {
                if (!selectedDates.length) {
                  const inputDates = [
                    instance.parseDate(checkInInput.value, dateFormat),
                    instance.parseDate(checkOutInput.value, dateFormat)
                  ];
                  instance.setDate(inputDates);
                  onRangeDateChange(inputDates, dateStr, instance);
                }
              },
              onChange: onRangeDateChange,
              onValueUpdate: onRangeDateChange,
              onClose: (selectedDates, dateStr, instances) => {
                setTimeout(() => onRangeDateChange(selectedDates, dateStr, instances));
              }
            });
          } else {
            /**
             * Separate datepickers
             */
            flatpickr(checkInDisplay, {
              ...flatPickrOpts,
              defaultDate: today,
              onReady: (selectedDates, dateStr, instance) => {
                setCheckInDate(today, instance);

                checkInDisplay.addEventListener('click', () => {
                  instance.toggle();
                });
              },
              onChange: (selectedDates, dateStr, instance) => {
                const checkInDate = selectedDates[0];
                // eslint-disable-next-line no-underscore-dangle
                const checkOutInstance = checkOutDisplay._flatpickr;
                const checkOutDate = checkOutInstance.selectedDates[0];
                const nextDate = getNextDate(checkInDate);

                setCheckInDate(checkInDate, instance);

                checkOutInstance.set('minDate', nextDate);

                if (checkInDate >= checkOutDate) {
                  checkOutInstance.setDate(nextDate);
                  setCheckoutDateSeparate(nextDate, checkOutInstance);
                }
              }
            });

            flatpickr(checkOutDisplay, {
              ...flatPickrOpts,
              defaultDate: tomorrow,
              onReady: (selectedDates, dateStr, instance) => {
                setCheckoutDateSeparate(selectedDates[0], instance);
                instance.set('minDate', selectedDates[0]);

                checkOutDisplay.addEventListener('click', () => {
                  instance.toggle();
                });
              },
              onChange: (selectedDates, dateStr, instance) => {
                setCheckoutDateSeparate(selectedDates[0], instance);
              }
            });
          }
        } else {
          /**
           * Single datepicker
           */
          flatpickr(checkInDisplay, {
            ...flatPickrOpts,
            defaultDate: new Date(),
            onReady: (selectedDates, dateStr, instance) => {
              setCheckInDate(selectedDates[0], instance);
              checkInDisplay.addEventListener('click', () => {
                instance.toggle();
              });
            },
            onChange: (selectedDates, dateStr, instance) => {
              setCheckInDate(selectedDates[0], instance);
            }
          });
        }
      }
    });
  }
}

export default Bookingmask;
